
import { client } from '@/common-utils/libraries/axios/axios';
import SIM_CARD from '../apiUrls';

const mutationAssignSimCards = (onSuccess, onError) => {
    return {
        mutationFn: ({ iccids, organizationId }) => {
            return client.post(SIM_CARD.ASSOCIATE.url, { iccids, client: organizationId });
        },
        // onError: (error, variables, context)
        onError: (error) => {
            onError(error);
        },
        // onSuccess: (data, variables, context)
        onSuccess: () => {
            onSuccess();
        },
        // onSettled: (data, error, variables, context)
        onSettled: () => {
            // Error or success... doesn't matter!
        }
    };
};

export default mutationAssignSimCards;